import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Budget from "../assets/images/budget.svg";
import Goals from "../assets/images/goals.svg";
const WhyPreQualified = () => {
  return (
    <div className="why-pre-qualified common-padding">
        <Container>
        <div className="common-header text-center">
            <h2>Why get pre-qualified?</h2>
            <p>It’s a quick way to know your budget and make your offer stronger when you find the perfect home.</p>
        </div>

        <Row className="g-4 justify-content-center">
            <Col md={6} lg={5}>
            <Card>
                <img src={Budget} alt=""></img>
                <h5>Know what's in your budget</h5>
                <p>
                Shop with confidence knowing that you pre-qualify for a home loan.
                </p>
            </Card>
            </Col>
            <Col md={6} lg={5}>
            <Card>
                <img src={Goals} alt=""></img>
                <h5>Reach your financing goals</h5>
                <p>
                Get connected with certified loan officers at Real Estate Home Loans or from 
                Real Estate network of lenders to answer your questions.
                </p>
            </Card>
            </Col>
        </Row>
        </Container>
    </div>
  );
};

export default WhyPreQualified;
